import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  setHelperText,
  WeekoffPlanner,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import SelectList from "../../../../../Component/SelectList/SelectList";
import createstore from "../../../../../store";
import "./index.css";
import Weekoffslider from "./Weekoffslider";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  slider: {
    padding: "22px 0px",
    width: "60px",
  },
  thumb: {
    backgroundColor: "red",
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
});

class Define extends React.Component {
  constructor(props) {
    const weekdays = [
      { key: 1, value: 0 },
      { key: 2, value: 0 },
      { key: 3, value: 0 },
      { key: 4, value: 0 },
      { key: 5, value: 0 },
    ];

    super(props);
    this.state = {
      value: "",
      weekdays,
      lastWeekoff: [],
      // lastWeekoff: [{ key: 1, value: 0 }],
      lastWeekoffWorking: false,
      open: false,
      weekoffpolicyid: "",
      weekDayoptions: [
        {
          displayvalue: 7,
          displayname: "Sunday",
          key: "HtSunday",
          value: "",
          open: false,
        },
        {
          displayvalue: 1,
          displayname: "Monday",
          key: "HtMonday",
          value: "",
          open: false,
        },
        {
          displayvalue: 2,
          displayname: "Tuesday",
          key: "HtTuesday",
          value: "",
          open: false,
        },
        {
          displayvalue: 3,
          displayname: "Wednesday",
          key: "HtWednesday",
          value: "",
          open: false,
        },
        {
          displayvalue: 4,
          displayname: "Thursday",
          key: "HtThursday",
          value: "",
          open: false,
        },
        {
          displayvalue: 5,
          displayname: "Friday",
          key: "HtFriday",
          value: "",
          open: false,
        },
        {
          displayvalue: 6,
          displayname: "Saturday",
          key: "Htsunday",
          value: "",
          open: false,
        },
      ],
      selectedWeekoffDay: [], // Need to remove this one
      weekoffdays: [],
      dayslist: [
        "",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      weekoffdetail: [],
      followLastWeekoff: false,
      subscriptionid: "",
      weekstartid: "",
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.OnNext,
    });
    if (this.props.Language.weekoff) {
      const text = this.props.Language.weekoff.Htweek;
      this.props.setHelperText({ helperText: text });
    }
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    const { weekoffdays } = weekoffPlannerInfo;
    if (weekoffdays == undefined) {
      this.GetWeekoffDays(0);
    } else {
      // handleClose
      this.setState({ weekoffdays: weekoffPlannerInfo.weekoffdays });
      this.creatWeekoffDetail(weekoffPlannerInfo.weekoffdays);
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.ChangeLanguage("weekoff,navigation");
    const { AuthenticationAction } = createstore.getState();
    const subscriptionid = AuthenticationAction.login.subscriptionid;

    this.setState({ subscriptionid }, () => {
      this.GetForm();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  GetWeekoffDays(weekoffpolicyid) {
    // let weekoffpolicyid = weekoffPlannerInfo.weekoffpolicyid;
    const URL = `/subscription/weekoffpolicydetail/${weekoffpolicyid}`;
    // this.props.CommonReducerAction('CLEARWEEKOFF', {})
    instance
      .get(URL)
      .then((result) => {
        const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
        weekoffPlannerInfo.weekoffdays = result.data.result;
        this.props.WeekoffPlanner({ ...weekoffPlannerInfo });

        this.setState({ weekoffdays: weekoffPlannerInfo.weekoffdays });
        this.creatWeekoffDetail(weekoffPlannerInfo.weekoffdays);
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetForm() {
    const URL = `account/globledefault/${this.state.subscriptionid}`;
    instance
      .get(URL)
      .then((result) => {
        this.state.weekDayoptions.forEach((option) => {
          this.handleClose(option);
        });
        const data = result.data.result[0];
        const { weekstartid } = data;
        this.setState({ weekstartid });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({ CommonError });
      });
  }

  creatWeekoffDetail(weekoffdaysObj) {
    const weekoffdetail = [];

    weekoffdaysObj.map((optionParent, indexParent) => {
      if (indexParent > 0 && optionParent.weekoffdetailid > -1) {
        let halfweekoffids =
          (optionParent.week1 == 1 ? "1," : "") +
          (optionParent.week2 == 1 ? "2," : "") +
          (optionParent.week3 == 1 ? "3," : "") +
          (optionParent.week4 == 1 ? "4," : "") +
          (optionParent.week5 == 1 ? "5," : "");
        halfweekoffids = halfweekoffids.replace(/,\s*$/, "");

        let fullweekoffids =
          (optionParent.week1 == 2 ? "1," : "") +
          (optionParent.week2 == 2 ? "2," : "") +
          (optionParent.week3 == 2 ? "3," : "") +
          (optionParent.week4 == 2 ? "4," : "") +
          (optionParent.week5 == 2 ? "5," : "");
        fullweekoffids = fullweekoffids.replace(/,\s*$/, "");

        const islasthalfweekoff = optionParent.lastweek == 1;
        const islastfullweekoff = optionParent.lastweek == 2;
        if (
          (islasthalfweekoff || islastfullweekoff) &&
          this.state.followLastWeekoff == false
        ) {
          this.setState({ followLastWeekoff: true });
        }
        const weekinfo = {
          weekoffdetailid: optionParent.weekoffdetailid,
          weekdayid: optionParent.weekdayid,
          fullweekoffids,
          halfweekoffids,
          islasthalfweekoff,
          islastfullweekoff,
        };

        weekoffdetail.push(weekinfo);
        this.UpdateweekoffPlannerReducer();
        // this.UpdateweekoffPlannerReducer();
      }
      return optionParent;
    });

    this.setState({ weekoffdetail }, () => {
      this.UpdateweekoffPlannerReducer();
    });
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  handleweekoffChange = (indexParent, index, event, value) => {
    console.log(
      "indexParent, index, event, value: ",
      indexParent,
      index,
      event,
      value,
    );
    const { weekoffdays } = this.state;
    // let day = weekoffdays.findIndex(x => x.weekdayid == indexParent)
    if (indexParent > -1) {
      switch (index - 1) {
        case 1:
          weekoffdays[indexParent].week1 = value;
          break;
        case 2:
          weekoffdays[indexParent].week2 = value;
          break;
        case 3:
          weekoffdays[indexParent].week3 = value;
          break;
        case 4:
          weekoffdays[indexParent].week4 = value;
          break;
        case 5:
          weekoffdays[indexParent].week5 = value;
          break;
        case 6:
          weekoffdays[indexParent].lastweek = value;
          break;
        default:
          break;
      }
      this.setState({ weekoffdays });
    }
    this.creatWeekoffDetail(weekoffdays);
    this.UpdateweekoffPlannerReducer();
  };

  FollowLastWeekoffPolicy(selectedItem) {
    this.setState({ followLastWeekoff: selectedItem.displayvalue }, () => {
      this.UpdateweekoffPlannerReducer();
    });
  }

  handleToggle = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  weekdayClose = () => {
    this.setState({ open: false });
  };

  handleClose = (option) => {
    const { weekoffdays } = this.state;
    const day = weekoffdays.findIndex(
      (x) => x.weekdayid == option.displayvalue,
    );
    if (day > -1) {
      weekoffdays[day].weekoffdetailid = 0;
      this.setState({ weekoffdays });
    } else {
      const dayweek = {
        weekdayid: option.displayvalue,
        weekoffdetailid: 0,
        week1: 0,
        week2: 0,
        week3: 0,
        week4: 0,
        week5: 0,
        lastweek: 0,
      };
      weekoffdays.push(dayweek);
      this.setState({ weekoffdays }, () => {
        this.UpdateweekoffPlannerReducer();
      });
    }
    this.creatWeekoffDetail(weekoffdays);
    this.UpdateweekoffPlannerReducer();
  };

  // addWeekoff = (option) => {};

  removeWeekoff = (option) => {
    const { weekoffdays } = this.state;
    const day = weekoffdays.findIndex((x) => x.weekdayid == option.weekdayid);
    if (day > -1) {
      weekoffdays[day].weekdayid = option.weekdayid;
      weekoffdays[day].weekoffdetailid = -1;
      weekoffdays[day].week1 = 0;
      weekoffdays[day].week2 = 0;
      weekoffdays[day].week3 = 0;
      weekoffdays[day].week4 = 0;
      weekoffdays[day].week5 = 0;
      weekoffdays[day].lastweek = 0;

      this.setState({ weekoffdays }, () => {
        this.UpdateweekoffPlannerReducer();
      });
    }

    this.creatWeekoffDetail(weekoffdays);
    this.UpdateweekoffPlannerReducer();
  };

  OnNext = () => {
    this.UpdateweekoffPlannerReducer();
    this.props.click();
  };

  UpdateweekoffPlannerReducer = () => {
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    weekoffPlannerInfo.weekoffdetail = this.state.weekoffdetail;
    this.props.WeekoffPlanner({ ...weekoffPlannerInfo });
  };

  render() {
    const { weekstartid } = this.state;

    const lastWeekoffWorking = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    return (
      <div>
        <div className="stepper-scroller padding-top-0 width98">
          <p className="add-label-active margin-bottom-16">
            <FormattedMessage
              id="Htweekstart"
              defaultMessage="As per global defaults, your week start's on"
            />
            <span className="t-bold">
              &nbsp;
              {weekstartid == 1
                ? "Monday"
                : weekstartid == 2
                ? "Tuesday"
                : weekstartid == 3
                ? "Wednesday"
                : weekstartid == 4
                ? "Thursday"
                : weekstartid == 5
                ? "Friday"
                : weekstartid == 6
                ? "Saturday"
                : weekstartid == 0
                ? "Sunday"
                : ""}
            </span>
          </p>

          <Grid container className="padding-right-30">
            <div className="weekoff-day">
              <div className="weekdays">
                <FormattedMessage id="Htweek" defaultMessage="Week" />
              </div>
              {this.state.weekoffdays.map((optionParent, indexParent) => (
                <React.Fragment>
                  {indexParent == 0 ? (
                    <React.Fragment>
                      {Object.keys(optionParent).map((result) => (
                        <React.Fragment>
                          {result != "weekdayid" &&
                            result != "lastweek" &&
                            result != "weekoffdetailid" && (
                              <div className="select-number">
                                Week{" "}
                                <FormattedMessage
                                  id={`Ht${optionParent[result]}`}
                                  defaultMessage={optionParent[result]}
                                />
                                {result == "week5" && (
                                  <p
                                    style={{
                                      display: "block",
                                      marginTop: -36,
                                      fontSize: 9,
                                    }}
                                  >
                                    (Only applies for month with 5 weeks)
                                  </p>
                                )}
                              </div>
                            )}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              ))}
            </div>

            {this.state.weekoffdays.map((optionParent, indexParent) => (
              <React.Fragment>
                {indexParent > 0 && optionParent.weekoffdetailid > -1 ? (
                  // {indexParent > 0 ? (
                  <div className="weekoff-day">
                    <React.Fragment>
                      <div className="aaa">
                        {Object.keys(optionParent).map((result, currentKey) => (
                          <React.Fragment>
                            {result != "weekoffdetailid" &&
                            result != "lastweek" ? (
                              <React.Fragment>
                                {result == "weekdayid" ? (
                                  <div className="weekdays">
                                    {this.state.dayslist[optionParent[result]]}
                                  </div>
                                ) : (
                                  <div>
                                    <div
                                      className={classNames(
                                        "select-weekoff",
                                        optionParent[result] == "2"
                                          ? "fullholiday"
                                          : optionParent[result] == "1"
                                          ? "halfholiday"
                                          : optionParent[result] == "0"
                                          ? "noholiday"
                                          : "",
                                      )}
                                    >
                                      <div>
                                        <Weekoffslider
                                          value={optionParent[result]}
                                          min={0}
                                          max={2}
                                          step={1}
                                          onChange={this.handleweekoffChange.bind(
                                            this,
                                            indexParent,
                                            currentKey,
                                          )}
                                        />
                                        {/* <WeekofSlider
                                                className="weekoff-slider"
                                                value={optionParent[result]}
                                                min={0}
                                                max={2}
                                                step={1}
                                                onChange={this.handleweekoffChange.bind(
                                                  this,
                                                  indexParent,
                                                  currentKey,
                                                )}
                                              /> */}
                                        <p className="week-off-label">
                                          {optionParent[result] == "2" ? (
                                            <FormattedMessage
                                              id="HtFullDayOff"
                                              defaultMessage="Full Day Off"
                                            />
                                          ) : optionParent[result] == "1" ? (
                                            <FormattedMessage
                                              id="Hthalfholiday"
                                              defaultMessage="Half Day Off"
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            ) : (
                              ""
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </React.Fragment>
                  </div>
                ) : (
                  ""
                )}
              </React.Fragment>
            ))}
            {/* <div className="weekoff-add-button">
              <div
                buttonRef={node => {
                  this.anchorEl = node;
                  // className={classnames(this.props.classes.expand, {
                  //     [this.props.classes.expandOpen]: item.open
                  // })}
                }}
                aria-owns={open ? "weekdaylist" : undefined}
                aria-haspopup="true"
                onClick={this.handleToggle}
              >
                {this.state.open == false ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    onClick={this.addWeekoff.bind(this)}
                  >
                    <path d="M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z" />
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" onClick={this.weekdayClose}>
                    <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
                  </svg>
                )}
              </div>
              <Popper open={open} anchorEl={this.anchorEl} transition disablePortal>
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    id="weekdaylist"
                    style={{
                      transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={this.weekdayClose}>
                        <MenuList>
                          {this.state.weekDayoptions.map(option => {
                            return (
                              <div>
                                <MenuItem onClick={this.handleClose.bind(this, option)}>
                                  <FormattedMessage
                                    id={option.key}
                                    defaultMessage={option.displayname}
                                  />
                                </MenuItem>
                              </div>
                            );
                          })}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
                        </div> */}
          </Grid>
          <div className="padding-top-30">
            <div className="inner-wrapper shift-planner-form">
              <div className="form-group">
                <p className="form-input-label">
                  Would you like to specify offs for the last week of any given
                  month, separately?
                </p>
                <SelectList
                  data={lastWeekoffWorking}
                  Selected={this.state.followLastWeekoff}
                  onSelected={this.FollowLastWeekoffPolicy.bind(this)}
                />
              </div>
            </div>
            {this.state.followLastWeekoff ? (
              <div>
                <div style={{ color: "#166ab3", marginBottom: 16 }}>
                  <FormattedMessage
                    id="noteonweeklyoff"
                    defaultMessage="Note: This will override the previous selection for 4th/5th weeks."
                  />
                </div>
                <div className="display-flex padding-right-30">
                  <div className="weekoff-day">
                    <div className="select-number">
                      <FormattedMessage
                        id="Htlast"
                        defaultMessage="Last Week"
                      />
                    </div>
                  </div>
                  {this.state.weekoffdays.map((optionParent, indexParent) => (
                    <React.Fragment>
                      {indexParent > 0 && optionParent.weekoffdetailid > -1 ? (
                        <div className="weekoff-day">
                          <div>
                            {Object.keys(optionParent).map(
                              (result, currentKey) => (
                                <React.Fragment>
                                  {result == "lastweek" ? (
                                    <div>
                                      <div
                                        className={classNames(
                                          "select-weekoff",
                                          optionParent[result] == "2"
                                            ? "fullholiday"
                                            : optionParent[result] == "1"
                                            ? "halfholiday"
                                            : optionParent[result] == "0"
                                            ? "noholiday"
                                            : "",
                                        )}
                                      >
                                        <div>
                                          <Weekoffslider
                                            value={optionParent[result]}
                                            min={0}
                                            max={2}
                                            step={1}
                                            onChange={this.handleweekoffChange.bind(
                                              this,
                                              indexParent,
                                              currentKey,
                                            )}
                                          />
                                          {/* <WeekofSlider
                                              className="weekoff-slider"
                                              value={optionParent[result]}
                                              min={0}
                                              max={2}
                                              step={1}
                                              onChange={this.handleweekoffChange.bind(
                                                this,
                                                indexParent,
                                                currentKey,
                                              )}
                                            /> */}
                                          <p className="week-off-label">
                                            {optionParent[result] == "2" ? (
                                              <FormattedMessage
                                                id="HtFullDayOff"
                                                defaultMessage="Full Day Off"
                                              />
                                            ) : optionParent[result] == "1" ? (
                                              <FormattedMessage
                                                id="Hthalfholiday"
                                                defaultMessage="Half Day Off"
                                              />
                                            ) : (
                                              ""
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </React.Fragment>
                              ),
                            )}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

Define.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  weekoffPlannerReducer: state.weekoffPlannerReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      WeekoffPlanner: (data) => WeekoffPlanner(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Define)));
